export default "__VITE_ASSET__qYD0CssJ__"